import { ChevronRight } from "lucide-react";
import { Category } from "@/hooks/useKnowledgeBase";

interface KnowledgeCategoryGridProps {
  categories: Category[];
  onSelectCategory: (categoryId: string) => void;
}

export function KnowledgeCategoryGrid({ categories, onSelectCategory }: KnowledgeCategoryGridProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-4">
      {categories.map((category) => (
        <div
          key={category.id}
          className="cursor-pointer rounded-xl border border-white/15 bg-white/8 hover:bg-psi-lime/30 transition-colors"
          onClick={() => onSelectCategory(category.id)}
        >
          <div className="p-4 pb-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 rounded-lg bg-psi-lime/10 flex items-center justify-center">
                  <category.icon className="w-5 h-5 text-psi-lime" />
                </div>
                <div>
                  <p className="text-base font-semibold text-white">{category.title}</p>
                  <p className="text-sm text-white/60">{category.description}</p>
                </div>
              </div>
              <ChevronRight className="w-5 h-5 text-white/40 flex-shrink-0" />
            </div>
            <div className="mt-2 pl-13">
              <p className="text-xs text-white/40">
                {(() => {
                  const count = category.subcategories
                    ? category.subcategories.length
                    : category.articles.length;
                  return `${count} recurso${count !== 1 ? "s" : ""}`;
                })()}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
